import { LitElement, html, css } from 'lit-all'
import { all } from 'lib-utils'

class NovaHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    isSticky: {
      type: Boolean,
      attribute: 'is-sticky',
    },
    isTransparent: {
      type: Boolean,
      attribute: 'is-transparent',
    },
    isScrolled: {
      type: Boolean,
      reflect: true,
      attribute: 'is-scrolled',
    },
  }

  constructor() {
    super()
    this.closeWhenHidden = 'nova-details-modal'
    this.isScrolled = false

    this.adjustCSSVariables()

    this.isSticky = this.hasAttribute('is-sticky')
  }

  connectedCallback() {
    super.connectedCallback()

    // Initially set the parent's sticky class if applicable
    if (this.isSticky) {
      this.parentElement.classList.add('is-sticky')
    }

    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    window.addEventListener('resize', this.adjustCSSVariables.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
    window.removeEventListener('resize', this.adjustCSSVariables.bind(this))
  }

  onScroll() {
    const scrollTop = window.window.scrollY || window.pageYOffSet || document.documentElement.scrollTop

    if (scrollTop > 0) {
      // If scrolled down, ensure the sticky attribute is set
      
      if (!this.hasAttribute('is-sticky')) {
        this.setAttribute('is-sticky', '')
        this.isSticky = true
        this.parentElement.classList.add('is-sticky')


      }
      if (!this.isScrolled) {
        this.isScrolled = true
      }
    } else {
      // If scrolled up (at the top), remove the sticky attribute
      if (this.hasAttribute('is-sticky')) {
        this.removeAttribute('is-sticky')
        this.isSticky = false
        this.parentElement.classList.remove('is-sticky')
      }
      if (this.isScrolled) {
        this.isScrolled = false
      }
    }

    this.adjustCSSVariables()
  }
  adjustCSSVariables() {
    const announcementHeight = this.querySelector('.js-header-announcement')?.offsetHeight || 0;
    const headerHeight = this.querySelector('.header')?.offsetHeight || 0;
    const totalOffset = announcementHeight + headerHeight;

    document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--header-offset', `${totalOffset}px`);

    if (this.isScrolled) {
    document.documentElement.style.setProperty('--header-offset', `${headerHeight}px`);

    } 
}

  render() {
    return html`
      <div class="container">
        <slot></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      position: relative;
      background-color: var(--header-bg-color);
      z-index: 99;
      height: 32px;
      transition: background-color 250ms, height 500ms;
    }

    :host([is-sticky]) {
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
    }

    :host([is-transparent]) {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    :host([is-sticky][is-transparent]) {
      position: fixed;
    }

    :host([is-transparent][is-sticky][is-scrolled]) {
      background-color: #fff;
    }

    .container {
      background-color: var(--nova-background, transparent);
      left: 0;
      top: 0;
      transform: translateY(0);
      transition: transform var(--nova-duration-long, 500ms);
      width: 100%;
      z-index: 10;
      position: relative;
    }

    :host([is-scrolled]) .container {
      transform: translateY(calc(0px - var(--announcement-height, 0)));
    }

    :host([is-scrolled]) {
      height: 0;
    }
  `
}

customElements.define('nova-header', NovaHeader)
